import { Component, OnInit, ViewChild, ElementRef, Input, Output, TemplateRef, EventEmitter } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as moment from 'moment';
import {  SalesBillentryService, CommonService, SubscribeService } from '../../../services/index';
import {SalesBillentryModel, ClientModel} from '../../../model/index';

@Component({
    selector: 'add-edit-emi-details-window',
    templateUrl: './addEditEmiDetails.component.html'
})
export class AddEditEmiDetailsComponent implements OnInit {
    title: string;
    //public referencedata: any[] = [];
    _emiAlldata: any[] = [];
    @Input() set emiAlldata(val: any[]) {
        this._emiAlldata = val;
        this.setPageData();
    }
    @Input() EmiDetailsdata: SalesBillentryModel[] = [];

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    isLoadMask: Promise<any>;
    // trigger-variable for Ladda
    isLoading: boolean = false;
    minDate: any;
    emi_type: string;
    emiTypeDisabled: boolean;

    reorderable: boolean = true;
    page = {
        limit: 20,
        count: 10,
        offset: 0,
        orderBy: 'bill_id',
        orderDir: 'asc'
    };
    columns = [];
    emiDetails = [];
    //	emiAlldata = [];
    constructor(private salesBillentryService: SalesBillentryService, public snackBar: MdSnackBar, public bsModalRef: BsModalRef, public toasterService: ToasterService, public subscribeService: SubscribeService) {
        this.emi_type = "SG Emi";
        this.emiTypeDisabled = false;
    }

    ngOnInit(): void {
        let that = this;
        this.EmiDetailsdata["emitype"] = "SG Emi";

        this.columnset();

        this.minDate = new Date(new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate());
    }

    columnset() {
        if(this.emi_type === "SG Emi") {
            this.columns = [
                { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, sortable: false, cellTemplate: this.snoTemplate },
                { name: 'Bank Name', prop: 'bankname', width: 130, minWidth: 130, maxWidth: 130 },
                { name: 'Chq No', prop: 'chqno', width: 130, minWidth: 130, maxWidth: 130 },
                { name: 'Chq DD', prop: 'disp_chqdd', width: 150, minWidth: 150, maxWidth: 150 },
                { name: 'Chq Amount', prop: 'chqamt', width: 120, minWidth: 120, maxWidth: 120, cellClass: 'cell-right' },
                { name: 'Action', prop: 'action', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
            ];
        } else {
            this.columns = [
                { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, sortable: false, cellTemplate: this.snoTemplate },
                { name: 'Emi Date', prop: 'disp_emidate', width: 130, minWidth: 130, maxWidth: 130 },
                { name: 'Emi Amount', prop: 'emiamt', width: 130, minWidth: 130, maxWidth: 130 },
                { name: 'Comments', prop: 'comments', width: 130, minWidth: 130, maxWidth: 130 },
                { name: 'Action', prop: 'action', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
            ];
        }
    }

    emiTypeChange() {
        if(this.EmiDetailsdata["emitype"] == "SG Emi") {
            this.emi_type = "SG Emi";
        } else {
            this.emi_type = "Bajaj Emi";
        }
        this.columnset();
    }


    onEnterKeyPressed(nextEl: string): void {
        $('#' + nextEl).focus();
    }

    setPageData(): void {
        //	this.emiAlldata = [];
        //this.emiAlldata       = this._emiAlldata;
        if (this._emiAlldata) {
            //	this.emiAlldata   = this._emiAlldata['emiAlldata'];
            // this.emiDetails = this._emiAlldata['emiDetails'];
            // let mode = this._params['mode'];
            //this.EmiDetailsdata = Object.assign({}, this._params);
            // if (mode == 'Edit') {
            //this.getSalesbillentryDetailList();
            //  this.salesbillentrydata['date'] = new Date(this._params['date']);//new Date();
            //  this.salesbillentrydata['hidden_client'] = this._params['client_no']; // FOR AUTO COMPLETE ALTERNATE
            // }
            this.emiDetails = this._emiAlldata["emiDetails"];
            if(this.emiDetails.length) {
                if(this.emiDetails[0].emitype === "SG Emi") {
                    this.emi_type = "SG Emi";
                    this.EmiDetailsdata["emitype"] = "SG Emi";
                } else {
                    this.emi_type = "Bajaj Emi";
                    this.EmiDetailsdata["emitype"] = "Bajaj Emi";
                }
                this.emiTypeDisabled = true;
            } else {
                this.emi_type = "SG Emi";
                this.EmiDetailsdata["emitype"] = "SG Emi";
            }
            this.columnset();
        }
    }


    getSalesbillentryDetailList(): void {
        let that = this,
            params = {
                start: `${this.page.offset}`,
                limit: `${this.page.limit}`,
                orderColumn: `${this.page.orderBy}`,
                orderBy: 'bill_id',
                orderDir: `${this.page.orderDir}`,
                bill_id: this.emiAlldata['bill_id'],
                bill_type: this.emiAlldata['tabParams']
            };
        this.isLoadMask = this.salesBillentryService
            .getSalesbillentryDetailList(params)
            .then(function(res: any) {
                that.page.count = res.totCnt;
                //  that.salesBillentryDetails = res.data;
                that.emiDetails = res.emiDet;
            });
    }


    onDeleteSalesbillentry(row: any): void {
        let that = this,
            mode = this._emiAlldata['mode'];
        if (mode == 'Add') {
            this.emiDetails.splice(this.emiDetails.indexOf(row), 1);
            if(!this.emiDetails.length) {
                this.emiTypeDisabled = false;
            }
        } else {
            let params = {
                bankname: row.bankname,
                chqno: row.chqno,
                chqdd: row.chqdd,
                chqamt: row.chqamt,
                bill_id: row.bill_id,
                id: row.id,
            };
            //this.emiDetails.splice(this.emiDetails.indexOf(row), 1);
            //  this.salesBillgriddata = [];

            this.salesBillentryService
                .deleteEmiList(params)
                .then(function(res: any) {
                    that.isLoading = false;
                    if (res.success) {
                        swal('SUCCESS', res.message, 'success');
                        that.emiDetails.splice(that.emiDetails.indexOf(row), 1);
                        //    that.getSalesbillentryDetailList();
                        //  that.calGrossTotal();
                        if (!that.emiDetails.length) {
                            that.emiTypeDisabled = false;
                        }
                    } else {
                        swal('ERROR', res.message, 'error');
                    }
                });
        }
    }
    addEmiDetails(): void {
        let that = this,
            mode = this._emiAlldata['mode'];

        if (mode == 'Add') {
            let that = this;
            if(this.emi_type == "SG Emi") {
                this.EmiDetailsdata['chqdd'] = moment(this.EmiDetailsdata['chqdd']).format('YYYY-MM-DD');
                this.EmiDetailsdata['disp_chqdd'] = moment(this.EmiDetailsdata['chqdd']).format('DD-MM-YYYY');
            } else {
                this.EmiDetailsdata['emidate'] = moment(this.EmiDetailsdata['emidate']).format('YYYY-MM-DD');
                this.EmiDetailsdata['disp_emidate'] = moment(this.EmiDetailsdata['emidate']).format('DD-MM-YYYY');
            }
            // this.EmiDetailsdata['emi_type'] = this.emi_type;
            let emiDet = Object.assign({}, this.EmiDetailsdata);
            this.emiDetails.push(emiDet);
            this.EmiDetailsdata = [];
            that.page.count = this.emiDetails.length;
            this.EmiDetailsdata["emitype"] = this.emi_type;
            this.emiTypeDisabled = true;
        } else if (mode == 'Edit') {
            if(this.emi_type == "SG Emi") {
                this.EmiDetailsdata['chqdd'] = moment(this.EmiDetailsdata['chqdd']).format('YYYY-MM-DD');
                this.EmiDetailsdata['disp_chqdd'] = moment(this.EmiDetailsdata['chqdd']).format('DD-MM-YYYY');
            } else {
                this.EmiDetailsdata['emidate'] = moment(this.EmiDetailsdata['emidate']).format('YYYY-MM-DD');
                this.EmiDetailsdata['disp_emidate'] = moment(this.EmiDetailsdata['emidate']).format('DD-MM-YYYY');
            }
            let params = {
                bankname: this.EmiDetailsdata['bankname'],
                chqno: this.EmiDetailsdata['chqno'],
                chqdd:  this.EmiDetailsdata['chqdd'],
                chqamt: this.EmiDetailsdata['chqamt'],
                bill_id: this._emiAlldata['bill_id'],
                emidate: this.EmiDetailsdata['emidate'],
                emiamt: this.EmiDetailsdata['emiamt'],
                comments: this.EmiDetailsdata['comments'],
                emitype: this.EmiDetailsdata['emitype']
            },

                emiDet = Object.assign({}, this.EmiDetailsdata);

            this.salesBillentryService
                .addEmiGridDetails(params)
                .then(function(res: any) {
                    that.isLoading = false;

                    if (res.success) {
                        swal('SUCCESS', res.message, 'success');

                        that.emiDetails.push(emiDet);
                        that.EmiDetailsdata = [];
                        that.page.count = that.emiDetails.length;
                        that.EmiDetailsdata["emitype"] = that.emi_type;
                        that.emiTypeDisabled = true;
                        that.getSalesbillentryDetailList();
                    } else {
                        swal('ERROR', res.message, 'error');
                    }
                })
        }
    }

    onSaveEmiDetails(): void {
        let that = this;

        if (this.emiDetails.length == 0) {
            let toast = {
                type: 'warning',
                title: 'WARNING',
                body: 'No Emi Details Data Found'
            };
            this.toasterService.pop(toast);
            return;
        }
        that.isLoading = true;
        let salesBillentryDate = moment(this._emiAlldata['date']).format('YYYY-MM-DD'),
            data = {
                bill_id: this._emiAlldata['bill_id'],
                auto_no: this._emiAlldata['auto_no'],
                date: salesBillentryDate,
                from_type: this._emiAlldata['from_type'],
                type: this._emiAlldata['type'],
                client_id: this._emiAlldata['client_id'],
                client_name: this._emiAlldata['client_name'],
                salesBillentryDetails: this._emiAlldata['salesBillentryDetails'],
                gross_total: this._emiAlldata['gross_total'],
                discount_percentage: this._emiAlldata['discount_percentage'],
                discount_amount: this._emiAlldata['discount_amount'],
                description: this._emiAlldata['description'],
                amount: this._emiAlldata['amount'],
                advances: this._emiAlldata['advances'],
                initial_amount: this._emiAlldata['initial_amount'],
                less_amount: this._emiAlldata['less_amount'],
                mode: this._emiAlldata['mode'],
                bill_type: this._emiAlldata['bill_type'],
                emiDetails: JSON.stringify(this.emiDetails),
                adv_bill_id: '',
                tot_qty: this._emiAlldata['tot_qty'],
                chqno: this._emiAlldata['chqno'],
                bank: this._emiAlldata['bank'],
                return_bill_amt: this._emiAlldata['return_bill_amt'],
                given_amount: this._emiAlldata['given_amount'],
                transaction_type: this._emiAlldata['transaction_type'],
                return_id: this._emiAlldata['return_id'],
                advance_type: this._emiAlldata['advance_type'],
                cash_amount : this._emiAlldata['cash_amount'],
                card_amount : this._emiAlldata['card_amount'],
                credit_amount: this._emiAlldata['credit_amount'],
                online_amount: this._emiAlldata['online_amount'],
                cheque_amount: this._emiAlldata['cheque_amount'],
                onlineno: this._emiAlldata['onlineno'],
                payment_type: this._emiAlldata['payment_type'],
                branch_id : this._emiAlldata['branch_id'],

            };

        this.salesBillentryService
            .addUpdatesalesBillentry(data)
            .then(function(res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.bsModalRef.hide();
                    that.subscribeService.subReloadSalesBillentryListGrid();
                    //that.testingbillUpdateEvent.emit();
                    that.EmiDetailsdata = [];
                    that.emiDetails = [];
                    that.subscribeService.subScribeDeleteActiveTab();
                } else {
                    swal('ERROR', res.message, 'error');
                }

            })
            .catch(function(error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
                //console.log(error);
            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/salesBillentry/addEditEmiDetails.component.ts